/*
  Google AdSense client loader.

  Unlike EthicalAds, AdSense uses cookies and requires Google Funding Choices
  for EU consent — Google handles the CMP automatically when the script
  loads, so we don't need to wrap this in our own consent gate.

  Docs: https://support.google.com/adsense/answer/9183549
*/

import { getConfig } from "./runtimeConfig";

let scriptInjected = false;

export function adsenseAvailable() {
  return !!getConfig().adsense_client_id;
}

export function getAdsenseSlot(format) {
  const c = getConfig();
  switch (format) {
    case "in-feed":        return c.adsense_slot_in_feed;
    case "desktop-inline": return c.adsense_slot_desktop_inline;
    case "sidebar":        return c.adsense_slot_sidebar;
    default: return null;
  }
}

export function loadAdSense() {
  if (!adsenseAvailable()) return;
  if (scriptInjected) return;
  scriptInjected = true;

  const clientId = getConfig().adsense_client_id;
  const s = document.createElement("script");
  s.async = true;
  s.crossOrigin = "anonymous";
  s.id = "verihandi-adsense";
  s.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${encodeURIComponent(clientId)}`;
  document.head.appendChild(s);

  window.adsbygoogle = window.adsbygoogle || [];
}

/*
  Initialise a single <ins class="adsbygoogle"> element. Must be called AFTER
  the element is in the DOM and has a non-zero width — otherwise AdSense
  throws "availableWidth=0". React strict-mode can double-mount so we mark
  the element with `data-ea-loaded` to no-op on subsequent calls.
*/
export function pushAdSenseSlot(el) {
  if (!el || !adsenseAvailable()) return;
  if (el.dataset.adLoaded === "1") return;
  // Defer one tick so layout has committed
  requestAnimationFrame(() => {
    try {
      if (!el.isConnected || el.offsetWidth === 0) return;
      (window.adsbygoogle = window.adsbygoogle || []).push({});
      el.dataset.adLoaded = "1";
    } catch (e) {
      // Silent — ad failures should never break the app
      // eslint-disable-next-line no-console
      console.warn("AdSense push error:", e && e.message);
    }
  });
}
